import { render, staticRenderFns } from "./dayHeadCard.vue?vue&type=template&id=6881f617&scoped=true"
import script from "./dayHeadCard.vue?vue&type=script&lang=ts"
export * from "./dayHeadCard.vue?vue&type=script&lang=ts"
import style0 from "./dayHeadCard.vue?vue&type=style&index=0&id=6881f617&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881f617",
  null
  
)

export default component.exports